import axios from 'axios'
import { Toast } from 'vant'

const request = axios.create({ baseURL: process.env.VUE_APP_BASE_API || '', timeout: 15000 })

request.interceptors.request.use(config => {
  const token = localStorage.getItem('h5_token')
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
})

request.interceptors.response.use(res => {
  const body = res.data || {}
  if (body.code === 401) {
    localStorage.removeItem('h5_token')
    if (location.hash.indexOf('#/login') !== 0) location.hash = '#/login'
    return Promise.reject(body)
  }
  if (body.code !== 200) {
    Toast(body.msg || '请求失败')
    return Promise.reject(body)
  }
  return body
}, error => {
  const status = error.response && error.response.status
  if (status === 401) {
    localStorage.removeItem('h5_token')
    if (location.hash.indexOf('#/login') !== 0) location.hash = '#/login'
  } else {
    const msg = error.response && error.response.data && error.response.data.msg
    Toast(msg || '网络异常')
  }
  return Promise.reject(error)
})

export default request
